import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbCollapseModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { ToastrModule } from 'ngx-toastr';

import { CoreCommonModule } from "@core/common.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";

import { AuthenticationModule } from "./authentication/authentication.module";
import { MiscellaneousModule } from "./miscellaneous/miscellaneous.module";
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "app/shared/shared.module";
import { NgxMaskModule } from "ngx-mask";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgxPaginationModule } from "ngx-pagination";
import { CoreTouchspinModule } from "@core/components/core-touchspin/core-touchspin.module";

import { ClienteService } from "@core/services/cliente.service";
import { FormClienteComponent } from "./cliente/form-cliente/form-cliente.component";
import { ListarClienteComponent } from "./cliente/listar-cliente/listar-cliente.component";
import { FormClienteContatoComponent } from "./cliente/form-cliente-contato/form-cliente-contato.component";
import { ListarSistemaComponent } from "./sistema/listar-sistema/listar-sistema.component";
import { FormSistemaComponent } from "./sistema/form-sistema/form-sistema.component";
import { ListarGrupoPermissaoComponent } from "./grupo-permissao/listar-grupo-permissao/listar-grupo-permissao.component";
import { FormGrupoPermissaoComponent } from "./grupo-permissao/form-grupo-permissao/form-grupo-permissao.component";
import { LoginComponent } from "./autenticacao/login/login.component";
import { InicioComponent } from "./inicio/inicio.component";
import { RedefinirSenhaComponent } from "./autenticacao/redefinir-senha/redefinir-senha.component";
import { CadastroExternoComponent } from './cliente/cadastro-externo/cadastro-externo.component';
import { ListarPedidoComponent } from "./pedido/listar-pedido/listar-pedido.component";
import { FormPedidoComponent } from "./pedido/form-pedido/form-pedido.component";
import { FormPlanoComponent } from './plano/form-plano/form-plano/form-plano.component';
import { ListarPlanoComponent } from './plano/listar-plano/listar-plano/listar-plano.component';
import { ListarChipComponent } from "./chip/listar-chip/listar-chip.component";
import { FormChipComponent } from "./chip/form-chip/form-chip.component";
import { FormContratoComponent } from "./contrato/form-contrato/form-contrato.component";
import { ListarContratoComponent } from './contrato/listar-contrato/listar-contrato.component';
import { ListarClienteFechamentoComponent } from './cliente-fechamento/listar-cliente-fechamento/listar-cliente-fechamento.component';
import { FormClienteFechamentoComponent } from './cliente-fechamento/form-cliente-fechamento/form-cliente-fechamento.component';
import { ViewClienteFechamentoComponent } from './cliente-fechamento/view-cliente-fechamento/view-cliente-fechamento.component';
import { ListarLeadComponent } from './lead/listar-lead/listar-lead.component';
import { FormLeadComponent } from './lead/form-lead/form-lead.component';
import { FormLeadContatoComponent } from './lead/form-lead-contato/form-lead-contato.component';
import { TabelaPrecoListComponent } from './tabela-preco/tabela-preco-list/tabela-preco-list.component';
import { TabelaPrecoFormComponent } from "./tabela-preco/tabela-preco-form/tabela-preco-form.component";
import { ListarFechamentoComponent } from './fechamento/listar-fechamento/listar-fechamento.component';
import { FormFechamentoComponent } from './fechamento/form-fechamento/form-fechamento.component';
import { DetalhamentoFechamentoComponent } from './fechamento/detalhamento-fechamento/detalhamento-fechamento.component';
import { ClientesFechamentoComponent } from './fechamento/clientes-fechamento/clientes-fechamento.component';
import { RelatorioChipsImportadosComponent } from './fechamento/relatorio-chips-importados/relatorio-chips-importados.component';
import { VendasFechamentoComponent } from './fechamento/vendas-fechamento/vendas-fechamento.component';
import { ListarRastreeiComponent } from "./pedido/listar-rastreei/listar-rastreei.component";
import { ListarFaleflexComponent } from "./pedido/listar-faleflex/listar-faleflex.component";
import { FormRastreeiComponent } from "./pedido/form-rastreei/form-rastreei.component";
import { FormFaleflexComponent } from "./pedido/form-faleflex/form-faleflex.component";
import { FornecedorFormComponent } from './fornecedor/fornecedor-form/fornecedor-form.component';
import { FornecedorListComponent } from './fornecedor/fornecedor-list/fornecedor-list.component';
import { FabricanteListComponent } from './fabricante/fabricante-list/fabricante-list.component';
import { FabricanteFormComponent } from './fabricante/fabricante-form/fabricante-form.component';
import { DespachanteListComponent } from './despachante/despachante-list/despachante-list.component';
import { DespachanteFormComponent } from './despachante/despachante-form/despachante-form.component';
import { RastreadorModeloListComponent } from './rastreador-modelo/rastreador-modelo-list/rastreador-modelo-list.component';
import { RastreadorModeloFormComponent } from './rastreador-modelo/rastreador-modelo-form/rastreador-modelo-form.component';
import { RastreadorListComponent } from './rastreador/rastreador-list/rastreador-list.component';
import { RastreadorFormComponent } from './rastreador/rastreador-form/rastreador-form.component';
import { RastreadorEntradaFormComponent } from './rastreador/rastreador-entrada-form/rastreador-entrada-form.component';
import { RastreadorEntradaListComponent } from './rastreador/rastreador-entrada-list/rastreador-entrada-list.component';
import { RastreadorManagementComponent } from './rastreador/rastreador-management/rastreador-management.component';
import { PedidoRastreadorListComponent } from './pedido/pedido-rastreador-list/pedido-rastreador-list.component';
import { PedidoRastreadorFormComponent } from './pedido/pedido-rastreador-form/pedido-rastreador-form.component';
import { PedidoIsencaoComponent } from './pedido/pedido-isencao/pedido-isencao.component';
import { ListarIsencaoComponent } from './pedido/listar-isencao/listar-isencao.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { BiFinanceiroComponent } from './bi-financeiro/bi-financeiro.component';
import { BiGraficoComponent } from './bi-financeiro/bi-grafico.component';

@NgModule({
	declarations: [
		ListarClienteComponent,
		FormClienteContatoComponent,
		FormClienteComponent,
		FormSistemaComponent,
		ListarSistemaComponent,
		ListarGrupoPermissaoComponent,
		FormGrupoPermissaoComponent,
		LoginComponent,
		InicioComponent,
		RedefinirSenhaComponent,
		CadastroExternoComponent,
		ListarPedidoComponent,
		FormPedidoComponent,
		FormPlanoComponent,
		ListarPlanoComponent,
		FormChipComponent,
		ListarChipComponent,
		ListarContratoComponent,
		FormContratoComponent,
		ListarClienteFechamentoComponent,
		FormClienteFechamentoComponent,
		ViewClienteFechamentoComponent,
		ListarLeadComponent,
		FormLeadComponent,
		FormLeadContatoComponent,
		TabelaPrecoListComponent,
		TabelaPrecoFormComponent,
		ListarFechamentoComponent,
		FormFechamentoComponent,
		DetalhamentoFechamentoComponent,
		ClientesFechamentoComponent,
		RelatorioChipsImportadosComponent,
		VendasFechamentoComponent,
		BiFinanceiroComponent,
		BiGraficoComponent,
		FornecedorListComponent,
		FornecedorFormComponent,
		FornecedorListComponent,
		FabricanteListComponent,
		FabricanteFormComponent,
		DespachanteListComponent,
		DespachanteFormComponent,
		RastreadorModeloListComponent,
		RastreadorModeloFormComponent,
		RastreadorListComponent,
		RastreadorFormComponent,
		RastreadorEntradaFormComponent,
		RastreadorEntradaListComponent,
		RastreadorManagementComponent,
		PedidoRastreadorListComponent,
		PedidoRastreadorFormComponent,
		ListarRastreeiComponent,
		ListarFaleflexComponent,
		FormRastreeiComponent,
		FormFaleflexComponent,
		PedidoIsencaoComponent,
		ListarIsencaoComponent
	],
	imports: [
		CommonModule,
		NgxPaginationModule,
		CoreTouchspinModule,
		CoreCommonModule,
		ContentHeaderModule,
		NgbModule,
		NgSelectModule,
		FormsModule,
		AuthenticationModule,
		MiscellaneousModule,
		ContentHeaderModule,
		CoreCommonModule,
		SharedModule,
		NgxMaskModule.forRoot(),
		NgxDatatableModule,
		ReactiveFormsModule,
		Ng2FlatpickrModule,
		MatAutocompleteModule,
		NgxDatatableModule,
		ContentHeaderModule,
		ToastrModule.forRoot(),
		RouterModule,
		NgbCollapseModule,
		NgxQRCodeModule
	],
	providers: [ClienteService],
})
export class PagesModule { }
